import React from 'react';

import PageTitleNew from 'components/ui/PageTitleNew';

import { useNavigate, useParams } from 'react-router-dom';

import Form from 'components/Admin/Avatars/Widget/Form';

import EmptyBlock from 'components/ui/EmptyBlock';

import actions from 'components/Admin/Avatars/Actions/Actions';

import useAvatar from 'components/Admin/Avatars/Hooks/useAvatar';

export default function Index() {
  const { id } = useParams();

  const navigate = useNavigate();

  const avatar = useAvatar({ id });

  const onSave = (values, onSuccess, onError) => {
    actions.update(id, values, () => {
      onSuccess();
      navigate('/admin/avatars');
    }, onError);
  };

  const onClose = () => {
    navigate('/admin/avatars');
  };

  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="Update AI Coach" />

      {avatar ? (
        <Form
          onSave={onSave}
          onClose={onClose}
          avatar={avatar.attributes}
        />
      ) : <EmptyBlock text="Loading..." />}
    </div>
  );
}
